import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "main-content-container p-15 p-sm-20 p-md-25" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_VabeneReferralReport = _resolveComponent("VabeneReferralReport");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('loyalty.referralReport')
        }, null, 8, ["PageTitle"]),
        _createVNode(_component_VabeneReferralReport)
    ]));
}
